import React from "react";
import { Helmet } from "react-helmet";
import "./AboutUs.css";

import lawyer_1 from "../assets/lawyer_2.png";

import {
  FaUsers,
  FaGavel,
  FaUniversity,
  FaBuilding,
  FaBriefcase,
  FaHandshake,
  FaGlobe,
  FaBalanceScale,
  FaLightbulb,
   FaFileInvoice,   // ✅ add this
  FaLaptopCode  
} from "react-icons/fa";

const AboutUs = () => {
  const practiceAreas = [
    {
      icon: <FaBalanceScale />,
      title: "Supreme Court",
      desc: "Litigation and legal representation before the Supreme Court of India.",
    },
    {
      icon: <FaGavel />,
      title: "High Courts",
      desc: "Representation before the Telangana and Andhra Pradesh High Courts and All High Courts across India.",
    },
    {
      icon: <FaBuilding />,
      title: "Company Law Tribunals",
      desc: "Advisory and litigation before the National Company Law Tribunal.",
    },
    {
      icon: <FaUsers />,
      title: "Tribunals & Fora",
      desc: "Labour, Consumer, Arbitration, and specialized tribunal matters.",
    },
    
    
    {
      icon: <FaUniversity />,
      title: "Civil & Criminal Courts",
      desc: "Effective trial and appellate court representation across matters.",
    },
     {
  icon: <FaUsers />,
  title: "Family Law",
  desc: "Handling matters such as divorce, child custody, maintenance, adoption, and family disputes with care and sensitivity.",
},
    {
  icon: <FaFileInvoice />,
  title: "Tax Law",
  desc: "Advisory and representation in income tax, GST, tax planning, and dispute resolution.",
},
    
  
   {
  icon: <FaLightbulb  />,
  title: "Intellectual Property Rights (IPR)",
  desc: "Registration, protection, and enforcement of trademarks, copyrights, patents, and other intellectual property rights.",
},
{
  icon: <FaLaptopCode />,
  title: "Cyber Law",
  desc: "Handling cybercrime cases, data protection issues, online fraud, and IT Act compliance.",
},
  {
    icon: <FaGlobe />,
    title: "Immigration Law",
    desc: "Legal assistance for visas, work permits, residency, and immigration-related matters.",
  },
 
    {
      icon: <FaHandshake />,
      title: "Dispute Resolution",
      desc: "Arbitration, mediation, settlement strategy, and legal negotiation.",
    },
  

 {
      icon: <FaBriefcase />,
      title: "Corporate Advisory",
      desc: "Strategic legal guidance for businesses, compliance, and operations.",
    },
  ];

  const coreValues = [
    {
      title: "Integrity & Ethics",
      desc: "Honesty, transparency, and strong moral principles guide every matter we handle.",
    },
    {
      title: "Client-Centric Service",
      desc: "We provide thoughtful, personalized legal attention with care and clarity.",
    },
    {
      title: "Legal Excellence",
      desc: "Our practice is built on strong legal knowledge, preparation, and execution.",
    },
    {
      title: "Collaboration & Teamwork",
      desc: "We work cohesively to achieve strong and practical outcomes for our clients.",
    },
    {
      title: "Commitment to Results",
      desc: "We remain focused on solutions that align with our clients’ goals.",
    },
    {
      title: "Innovation",
      desc: "We embrace modern legal strategy and evolving tools without compromising values.",
    },
  ];

  return (
    <div className="about-us-page">
      <Helmet>
        <title>About Us | Yadi Legal Services</title>
      </Helmet>

      <section className="about_top">
        <div className="about-overlay"></div>
        <div className="glassy-banner">
          <p className="about-kicker">Trusted | Experienced | Committed</p>
          <h1 className="about-main-title">About Us</h1>
          <p className="about-banner-text">
            Delivering dependable legal counsel with integrity, clarity, and commitment.
          </p>
        </div>
      </section>

      <div className="container">
        <section className="about-section">
          <div className="about-content">
            <div className="about-text">
              <span className="section-label">Who We Are</span>
              <h2>
                About <span>Yadi Legal Services</span>  & Founding Leadership
              </h2>
              <hr />
              <p>
                At Yadi Legal Services, delivering high-quality legal advice and service
                to every client is our highest priority. We focus on understanding
                each client’s legal and business needs in order to offer practical,
                strategic, and solution-oriented Advocacy.
              </p>
              <p>
                Our team-based approach allows us to bring fresh thinking to every
                legal challenge. We believe that strong representation combines legal
                excellence with responsiveness, integrity, and a deep commitment to
                justice.
              </p>
              <p>
                The firm was founded by <strong>YADISHWAR.N</strong>, whose
                decades of legal experience continue to shape the firm’s values,
                standards, and client-first philosophy.
              </p>

              <div className="about-stats">
                <div className="stat-card">
                  <h3>12+</h3>
                  <p>Years of Legal Insight</p>
                </div>
                <div className="stat-card">
                  <h3>22+</h3>
                  <p>Our Practice Areas</p>
                </div>
                <div className="stat-card">
                  <h3>100%</h3>
                  <p>Client-Focused Approach</p>
                </div>
              </div>
            </div>

            <div className="about-image">
              <img src={lawyer_1} alt="Shireen Sethna Baria" />
            </div>
          </div>
        </section>
  {/* ✅ NEW QUALIFICATION SECTION */}
        <section className="qualification-section">
  <span className="section-label center">Professional Profile</span>
  <h2 className="section-title">Qualifications & Credentials</h2>

  <div className="qualification-container">

    <div className="qualification-card">
      <h3>🎓 Academic Excellence</h3>
      <ul>
        <li>B.Com (TTM)</li>
        <li>MBA</li>
        <li>LL.B</li>
        <li>PGDTIL</li>
        <li>LL.M</li>
      </ul>
    </div>

    <div className="qualification-card">
      <h3>⚖️ Professional Standing</h3>
      <ul>
        <li>High Court Advocate</li>
        <li>Panel Advocate – Legal Services Committee</li>
        <li>Extensive Practice Across Courts & Tribunals</li>
      </ul>
    </div>

  </div>
</section>
        <section className="team-section">
          <span className="section-label center">Practice Strength</span>
          <h2 className="section-title">The Team and Practice Areas</h2>
          <p className="section-intro">
            The partners at <strong>Yadi Legal Services</strong> represent clients
            before courts, tribunals,commissions and legal forums across India, offering a
            combination of litigation strength, advisory capability, and practical
            legal strategy.
          </p>

          <div className="practice-cards">
            {practiceAreas.map((item, index) => (
              <div className="practice-card-wrapper" key={index}>
                <div className="practice-card">
                  <div className="icon">{item.icon}</div>
                  <h4>{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="about-philosophy premium-block">
          <span className="section-label center">Our Philosophy</span>
          <h2>Philosophy and Reach</h2>
          <p>
            Yadi Legal Services believes in integrity, ethics, sensitivity, and
            professional excellence. Every case is handled with confidentiality,
            meticulous preparation, and a strong commitment to justice.
          </p>
          <p>
            Our philosophy is centered on building long-term client relationships
            through consistent results, transparent communication, and legal
            strategies tailored to each matter.
          </p>
          <p>
            Over the years, the firm has expanded its reach across multiple legal
            domains including constitutional law, corporate law, civil litigation, criminal defense,
            property disputes, and family law. We serve businesses, individuals,
            and communities with the same seriousness and dedication.
          </p>

          <ul>
            <li>Client-Centric Approach</li>
            <li>Uncompromising Integrity</li>
            <li>Continuous Legal Research</li>
            <li>Collaborative Problem Solving</li>
            <li>Effective Representation at All Judicial Levels</li>
          </ul>

          <p>
            Yadi Legal Services continues to evolve with the legal landscape while
            remaining rooted in the enduring principles of fairness, justice,
            and professional responsibility.
          </p>
        </section>

        <section className="about-philosophy">
          <span className="section-label center">What Drives Us</span>
          <h2>Our Core Values</h2>

          <div className="core-values">
            {coreValues.map((item, index) => (
              <div key={index}>
                <strong>{item.title}</strong>
                {item.desc}
              </div>
            ))}
          </div>
        </section>

        <section className="mission-vision">
          <div className="mission">
            <span className="mini-label">Our Mission</span>
            <h2>Purpose With Precision</h2>
            <p>
              To deliver innovative, practical, and cost-effective legal
              solutions by combining legal expertise with strategic insight,
              while maintaining the highest standards of integrity and service.
            </p>
          </div>

          <div className="vision">
            <span className="mini-label">Our Vision</span>
            <h2>Trust Through Excellence</h2>
            <p>
              To be a trusted legal partner known for excellence in advocacy,
              reliability in counsel, and an unwavering dedication to client
              success across every stage of representation.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AboutUs;